import router from "@/router/index.js";
import { getToken } from "@/utils/auth";

// router.beforeEach((to, from, next) => {
//   let token = localStorage.getItem('sessionKey')
  
//   // 未登录且要跳转的页面不是登录页
//   if(!token && to.name !== 'Login'){
//     next({ name: 'Login' })
//     // 未登陆且要跳转的页面是登录页
//   } else if (!token && to.name == 'Login') {
//     next()
//     // 已登录且要跳转的页面是登录页
//   } else if(token && to.name == 'Login'){
//     next({ name: 'Index' })
//   } else {
//     next()
//   }
// })

export default router